interface NestError {
  response: {
    data: {
      message: string;
    };
  };
}

const isNestError = (x: unknown): x is NestError => {
  const typedX = x as NestError;
  return typeof typedX?.response?.data?.message === 'string';
};

const manageTextError = (error: unknown, setError: (error: string) => void) => {
  if (isNestError(error)) {
    return setError(
      error.response.data.message.replace(
        'Bad Request',
        'Une erreur est survenue',
      ),
    );
  }
  return setError('Une erreur est survenue.');
};

export default manageTextError;
